import React, { useEffect } from 'react'
import { useMediaQuery } from '@mantine/hooks'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Box, Radio } from '@node-space/ui-components'
import { useRewardsSheetContext } from '../../context/RewardsSheetProvider'
import { RewardsEmbeddedTabsEnum } from '../../hooks/useRewardsEmbeddedTabs'
import { WithdrawSource, type RewardsWithdrawFormData } from '../../types'

interface RewardsWithdrawSourceRadioProps {
  disabled?: boolean
  testId?: string
}

export const RewardsWithdrawSourceRadio: React.FC<RewardsWithdrawSourceRadioProps> = ({
  disabled = false,
  testId = 'withdraw-source-radio',
}) => {
  const { t } = useTranslation()
  const { watch, setValue } = useFormContext<RewardsWithdrawFormData>()
  const { activeTab } = useRewardsSheetContext()
  const isMobileScreen = useMediaQuery('(min-width: 640px)')

  const withdrawSource = watch('withdrawSource')

  useEffect(() => {
    if (activeTab === RewardsEmbeddedTabsEnum.MY_REWARDS) {
      setValue('withdrawSource', 'myRewards')
    } else if (activeTab === RewardsEmbeddedTabsEnum.CUSTOMER_REWARDS) {
      setValue('withdrawSource', 'customerRewards')
    }
  }, [activeTab, setValue])

  const radioOptions = [
    {
      label: t('rewards.withdraw.withdrawMyRewards'),
      value: 'myRewards',
    },
    {
      label: t('rewards.withdraw.withdrawFromCustomerRewards'),
      value: 'customerRewards',
    },
  ]

  const handleChange = (value: string) => {
    setValue('withdrawSource', value as WithdrawSource, { shouldValidate: true })
    // Reset amount when switching between sources
    setValue('amount', '')
  }

  return (
    <Box width="full" flexCol gapY={8} className="ml-[-12px]">
      <Radio
        testId={testId}
        horizontal={isMobileScreen}
        onChange={handleChange}
        options={radioOptions}
        value={withdrawSource}
        border={false}
        disabled={disabled}
      />
    </Box>
  )
}
